// extracted by mini-css-extract-plugin
module.exports = {"greenColorFlag":"TableCellColorWrap_greenColorFlag__2TG8d","redColorFlag":"TableCellColorWrap_redColorFlag__2PBZK","yellowColorFlag":"TableCellColorWrap_yellowColorFlag__3CoaD"};